import v15Schema from '../client/schemaVersions/v15.js';
import v16Schema from '../client/schemaVersions/v16.js';
import { createMigration } from '@verdant-web/store';
import { readRawIdb } from '../readRawIdb.js';
export default createMigration(v15Schema, v16Schema, async ({ mutations }) => {
    // load recipes from the recipes database into the groceries database
    // - this migration consolidates both into one library
    var _a;
    try {
        await readRawIdb('recipes_collections', 7, 'recipes', async (recipe) => {
            await mutations.recipes.put(recipe);
        });
    }
    catch (e) {
        if ((_a = e === null || e === void 0 ? void 0 : e.message) === null || _a === void 0 ? void 0 : _a.includes('One of the specified object stores was not found')) {
            // this is expected if the recipes database doesn't exist
            return;
        }
        console.error('Error migrating recipes', e);
    }
});
//# sourceMappingURL=v16.js.map